<form (ngSubmit)="onSubmit()">
    <div class="title-outer">
        <h2 class="form-title">{{ languageService.languageJSON.StartApprovalRollout_Title }}</h2>
    </div>

    <div class="form-section">
        <div class="flex-row assign-bikes-title" [hidden]="loading">
            <label>
                <div class="assign-bikes-detail">
                    <span>{{ languageService.languageJSON.StartApprovalRollout_SelectedSoftware }}: </span><b>{{
                        releaseId}}</b>
                </div>
                <div class="assign-bikes-detail">
                    <span>{{ languageService.languageJSON.ReleaseDetails_Name }}: </span><b>{{
                        fileName}}</b>
                </div>
                <div class="assign-bikes-detail">
                    <span>{{ languageService.languageJSON.ComponentDetails_ComponentName }}: </span><b>{{
                        componentName}}</b>
                </div>
                <div class="assign-bikes-detail">
                    <span>{{ languageService.languageJSON.ComponentVariant_ComponentVariant }}: </span><b>{{
                        variantName}}</b>
                </div>
            </label>
        </div>

        <div class="flex-outer" [hidden]="loading">
            <div class="flex-col large-col">
                <div class="flex-row  no-margin id-list-col">
                    <div class="bike-ids-outer">
                        <div class="fileover-indicator">
                            <div class="drop-elements">
                                <img src="assets/icons/drop-here.svg" />
                                <p> {{languageService.languageJSON.ConfigurationAssignBikes_DropFilesHere }}</p>
                            </div>
                        </div>
                        <div class="flex-row assign-title">
                            <label>{{ languageService.languageJSON.StartApprovalRollout_AvailableIds }}</label>
                        </div>
                        <div class="search">
                            <input name="newIdsSearch" [(ngModel)]="newIdsSearch"
                                (ngModelChange)="resetNewBikeSelection()">
                            <img src="assets/icons/search-line.svg" />
                        </div>

                        <div class="selected-counter">
                            {{ getDeleteNewBikeIds().length + "/" + newBikes.length }}
                        </div>

                        <div class="id-list">
                            <ng-scrollbar [orientation]="'vertical'">
                                <div class="id-list-el"
                                    *ngFor="let newBike of newBikes | searchProperty : 'id' : newIdsSearch; let index = index;">
                                    <mat-checkbox color="primary" [name]="'deleteNewBike' + index"
                                        [(ngModel)]="newBike.checked" [ngModelOptions]="{standalone: true}"
                                        (change)="shiftSelectNewBikeId($event, index)"
                                        [ngClass]="{'last-selected': lastSelectedIndexNewBikeIds==index}"></mat-checkbox>

                                    <div class="name">{{ newBike.id }}</div>
                                </div>
                            </ng-scrollbar>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex-col add-col">
                <div class="add-outer" (click)="assignBikeIds()">
                    <img class="angle-icon" src="assets/icons/line-angle-right.svg" />
                </div>
                <div class="add-outer" (click)="removeBikeIds()">
                    <img class="angle-icon reverse-icon" src="assets/icons/line-angle-right.svg" />
                </div>
            </div>

            <div class="flex-col large-col">
                <div class="flex-row no-margin">
                    <div class="bike-ids-outer">
                        <div class="flex-row assign-title">
                            <label>{{ languageService.languageJSON.StartApprovalRollout_SelectedIds }}</label>
                        </div>
                        <div class="search">
                            <input name="idsSearch" [(ngModel)]="idsSearch"
                                (ngModelChange)="resetAssignedBikeSelection()">
                            <img src="assets/icons/search-line.svg" />
                        </div>
                        <div class="selected-counter">
                            {{ getDeleteBikeIds().length + "/" + assignedBikes.length }}
                        </div>
                        <div class="id-list current">
                            <ng-scrollbar [orientation]="'vertical'">
                                <div class="id-list-el"
                                    *ngFor="let assignedBike of assignedBikes | searchProperty : 'id' : idsSearch; let index = index;">
                                    <mat-checkbox color="primary" [name]="'deleteBike' + index"
                                        [(ngModel)]="assignedBike.checked" [ngModelOptions]="{standalone: true}"
                                        (change)="shiftSelectBikeId($event, index)"
                                        [ngClass]="{'last-selected': lastSelectedIndexBikeIds==index}">
                                    </mat-checkbox>
                                    <div class="name">{{ assignedBike.id }}</div>
                                </div>
                            </ng-scrollbar>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="flex-row center" *ngIf="assignedBikesError && !loading">
            <h5 class="error">
                {{ languageService.languageJSON.StartApprovalRollout_NoBikesAddedError }}
            </h5>
        </div>
    </div>

    <app-add-rule [hidden]="loading" #rejectionRule
        [title]="languageService.languageJSON.StartApprovalRollout_AutomaticRejectionRules"></app-add-rule>
    <app-add-rule [hidden]="loading" #approvalRule
        [title]="languageService.languageJSON.StartApprovalRollout_AutomaticApprovalRules"></app-add-rule>

    <app-loading-animation *ngIf="loading"></app-loading-animation>

    <h5 class="error duplication-error" *ngIf="duplicationError">
        {{ languageService.languageJSON.StartApprovalRollout_SameRuleError }}
    </h5>

    <h5 class="error duplication-error" *ngIf="backendError">
        {{ languageService.languageJSON.Global_ServerError_Snackbar }}
    </h5>

    <div class="form-section-send" *ngIf="!loading">
        <button type="submit">{{ languageService.languageJSON.Global_Save}}</button>
    </div>
</form>